export default "__VITE_ASSET__CeCtcbfd__"